// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".other-document-field-container{border:1px solid #7100da;border-radius:.25rem}.other-document-field-container .card-header{background:#fff}.changeDocumentType .description{border-bottom:1px solid #e8e8e8}.required{padding-right:0}.el-dialog__footer .proceed-btn{padding:8px 12px}.applicants-form .application-form .el-button.add-other-doc-btn{width:100%}.other-document-type-label{margin-right:-28px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
